import { useEffect, useState } from "react";
import useScript from "./useScript";
import { formConfig } from "../formConfig.js";

const { REACT_APP_MP_PUBLIC_KEY, REACT_APP_BASE_URL } = process.env;

export default function useMercadoPago() {
  const [resultPayment, setResultPayment] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);

  const { MercadoPago } = useScript(
    "https://sdk.mercadopago.com/js/v2",
    "MercadoPago"
  );

  useEffect(() => {
    if (MercadoPago) {
      const mp = new MercadoPago(REACT_APP_MP_PUBLIC_KEY);
      const cardForm = mp.cardForm({
        amount: "10",
        autoMount: true,
        form: formConfig,
        callbacks: {
          onFormMounted: (error) => {
            if (error)
              return console.warn("Form Mounted handling error: ", error);
          },

          onSubmit: (event) => {
            event.preventDefault();
            setIsLoading(true);

            const { cardholderEmail: email, token } =
              cardForm.getCardFormData();

            const userToken = localStorage.getItem("token");
            if (!userToken) return;
            const restaurant = localStorage.getItem("restaurant");
            if (!restaurant) return;
            const restaurantId = JSON.parse(restaurant)._id;

            fetch(`${REACT_APP_BASE_URL}/restaurants/subscribe`, {
              method: "POST",
              headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Request-Method":
                  "GET, POST, DELETE, PUT, OPTIONS",
                "Content-Type": "application/json",
                Authorization: `Bearer ${userToken}`,
              },
              body: JSON.stringify({
                token,
                payer: {
                  email,
                },
                restaurant: restaurantId,
              }),
            })
              .then((res) => res.json())
              .then((data) => {
                setResultPayment(data);
                setIsLoading(false);
              })
              .catch((err) => {
                setResultPayment(err);
                setIsLoading(false);
              });
          },
        },
      });
    }
  }, [MercadoPago]);

  return { resultPayment, isLoading };
}
